import React from "react";
import { useHistory } from "react-router-dom";
import { UilReceipt } from "@iconscout/react-unicons";
import { ReceiptOutlined } from "@material-ui/icons";
import Button from "@mui/material/Button";
import PageLayout from "../PageLayout/PageLayout";
import "./Receipts.css";

const Receipts = () => {
  const history = useHistory();
  
  return (
    <PageLayout
      icon={UilReceipt}
      title="Order Receipts"
      subtitle="View and download your order receipts"
    >
      <div className="receipts-empty-state-container">
        <div className="receipts-empty-state-content">
          <div className="receipts-empty-state-icon-wrapper">
            <ReceiptOutlined className="receipts-empty-state-icon" />
          </div>
          <h3 className="receipts-empty-state-title">No Receipts Available</h3>
          <p className="receipts-empty-state-description">
            You don't have any order receipts yet. Place an order to receive automated receipts for your purchases.
          </p>
          <Button
            variant="contained"
            className="receipts-shop-now-button"
            onClick={() => history.push("/")}
            startIcon={<ReceiptOutlined />}
          >
            Start Shopping
          </Button>
        </div>
      </div>
    </PageLayout>
  );
};

export default Receipts;
